export const transferFieldData = (props) => {
  const {
    changePageValues,
    setChangePageValues,
    curPageValues,
    setCurPageValues,
    selectedVal,
  } = props.dataObject;
  const {
    dataTransferMapping,
    compareToValue,
  } = props.operation;
  if (dataTransferMapping && dataTransferMapping.mapping) {
    dataTransferMapping.mapping.forEach((mapping) => {
      const fromFieldIds = Array.isArray(mapping.fromFieldId)
        ? mapping.fromFieldId : [mapping.fromFieldId];
      fromFieldIds.forEach((fromFieldId) => {
        if (selectedVal === compareToValue) {
          changePageValues[mapping.toFieldId] = changePageValues[fromFieldId] || '';
          curPageValues[mapping.toFieldId] = changePageValues[fromFieldId] || '';
        } else {
          changePageValues[mapping.toFieldId] = '';
          curPageValues[mapping.toFieldId] = '';
        }
      });
    });
    setChangePageValues({ ...changePageValues });
    setCurPageValues({ ...curPageValues });
  }
};
